import React, { useEffect, useState } from 'react'
import {
    Card,
    Chip,
    Grid,
    Tooltip
} from '@material-ui/core'
import { components } from 'cng-web-lib'
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import TradeManagementTranslationText from "../shared/TradeManagementTranslationText";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/pro-light-svg-icons";
import RulesOfOriginListCardDetailBottom from "./RulesOfOriginListCardDetailBottom";
import RulesOfOriginDeminimisDetailsTop from './RulesOfOriginDeminimisDetailsTop'

const {
    CngGridItem
} = components

const initialValues = Object.freeze({})

const useStyles = makeStyles((theme) => ({
    fnButtonCircle: {
        '& .ng-button-func': {
            borderRadius: '50% !important',
            '&.medium': {

                width: '32px',
                height: '32px',
                minHeight: '32px',

                boxShadow: 'none',
                backgroundColor: 'transparent',
                borderWidth: '0'
            },
            '& svg': {
                backgroundColor: theme.palette.text.textSecondary,
                borderRadius: '50%',
                color: theme.palette.color.white,
                fontSize: '20px !important',
                padding: '4px'
            }
        }
    },
    tooltipContent: {
        fontSize: '14px',
        fontWeight: 400
    },
    tooltipLabel: {
        fontSize: '14px',
        fontWeight: 400
    },
    chipInfo: {
        color: theme.palette.text.textSecondary,
        cursor: 'pointer',
        fontWeight: 500,
        paddingBlock: '15px'
    },
    chipLabel: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'none',

        '& svg': {
            fontSize: '20px',
            marginInlineStart: '5px'
        }
    }
}))

const FormBody = (props) => {
    const classes = useStyles()
    const {
        originCalculation: {
            assessor
        },
        deminimisRooHolder
    } = props.product

    const FtaTranslatedTextsObject = TradeManagementTranslationText()

    const [deminimisStatus, setDeminimisStatus] = useState(deminimisRooHolder?.deminimisStatus)
    const [qvcRvc, setQvcRvc] = useState("-")
    const [deminimisCalculation, setDeminimisCalculation] = useState("-")
    const [concatenatedRules, setConcatenatedRules] = useState("")

    const [datesCardKey, setDatesCardKey] = useState(1)
    const [dates, setDates] = useState({
        qualificationDate: deminimisRooHolder.qualificationDate,
        qualificationExpiry: deminimisRooHolder.qualificationExpiry
    })

    useEffect(() => {

        if(deminimisRooHolder?.ftaOriginCalculationEntity?.qvc !== null && deminimisRooHolder?.ftaOriginCalculationEntity?.rvc !== null) {
            setQvcRvc(Number(deminimisRooHolder.ftaOriginCalculationEntity.qvc).toFixed(2) + '/' + Number(deminimisRooHolder.ftaOriginCalculationEntity.rvc).toFixed(2))
        } else if(deminimisRooHolder?.ftaOriginCalculationEntity?.qvc !== null) {
            setQvcRvc(deminimisRooHolder.ftaOriginCalculationEntity.qvc)
        } else if (deminimisRooHolder.ftaOriginCalculationEntity.rvc !== null) {
            setQvcRvc(deminimisRooHolder.ftaOriginCalculationEntity.rvc)
        } else {
            setQvcRvc("-")
        }

        if(deminimisRooHolder?.ftaOriginCalculationEntity?.actualNonOriginatingContent != null) {
            let c = deminimisRooHolder?.ftaOriginCalculationEntity?.actualNonOriginatingContent
            setDeminimisCalculation(Number(c).toFixed(2) + "%")
        } else {
            setDeminimisCalculation("-")
        }

        const criterianList = deminimisRooHolder?.deminimisEntityList.map((c, index) => {
            return (
                c.productSpecificRule
            );
        })
        const uniqueCriterianList = Array.from(new Set(criterianList));

        setConcatenatedRules(uniqueCriterianList.map(item => item).join(' | '))

    },[])

    return (
        <Card className={`summary-list-item--card`}>

            {/* start card header*/}
            <RulesOfOriginDeminimisDetailsTop
                assessor={assessor}
                deminimisStatus={deminimisStatus}
                setDeminimisStatus={setDeminimisStatus}
                handleSetQualificationDate={props.handleSetQualificationDate}
                deminimisRooHolder={deminimisRooHolder}
                dataIndex={props.dataIndex}
                dates={dates}
                setDates={setDates}
                datesCardKey={datesCardKey}
                setDatesCardKey={setDatesCardKey}
                productStatusCode={props?.productStatusCode}
            />
            {/* end card header*/}

            {/* start card body */}
            <div className={`cng-summary-card--body-box`}>
                <Grid container className={`cng-summary-card--body-grid`}>
                    <CngGridItem xs={12} sm={3}>
                        <div className={`field-vertical--label-value`} style={{marginInlineStart: '12px'}}>
                            <span className={`field-vertical--item`}>
                                <label
                                    className={`field-value clamp-line-to-two font-16 pr-10`}
                                    style={{textOverflow: 'ellipsis', overflow: 'hidden', wordBreak: 'break-word'}}
                                >
                                  <Tooltip
                                      title={deminimisRooHolder?.deminimisEntityList[0]?.criterion}
                                      placement='bottom'
                                      className={classes.tooltipContent}
                                      classes={{
                                          tooltip: classes.tooltipLabel
                                      }}
                                  >
                                    <p>
                                      {deminimisRooHolder?.deminimisEntityList[0]?.criterion}
                                    </p>
                                  </Tooltip>
                                </label>
                            </span>

                            <span className={`field-vertical--item`}>
                                <label className={`field-label font-14 font-mediumBold`}>
                                    {`-`}
                                </label>
                            </span>

                            <span className={`field-vertical--item`}>
                                <label className={`field-label font-14 pr-10`}>
                                  <Tooltip title={concatenatedRules} placement='bottom' className={classes.tooltipContent}
                                      classes={{tooltip: classes.tooltipLabel}}
                                  >
                                    <Chip
                                        label={
                                            <>
                                                Product Specific Rule
                                                <FontAwesomeIcon icon={faCircleInfo}/>
                                            </>
                                        }
                                        classes={{
                                            label: classes.chipLabel
                                        }}
                                        size='small'
                                        className={classes.chipInfo}
                                    />
                                  </Tooltip>
                                </label>
                            </span>
                        </div>
                    </CngGridItem>

                    <CngGridItem xs={12} sm={9}>
                        <Grid container>
                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.calculation}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>
                                            {deminimisCalculation}
                                        </label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>
                                            {FtaTranslatedTextsObject.thresholdValuePerUOM}
                                        </label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>
                                            {deminimisRooHolder?.ftaOriginCalculationEntity?.thresholdValuePerUom !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.thresholdValuePerUom).toFixed(2) : `-`}
                                        </label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.profit}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.profit !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.profit).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.nonOriginatingValue}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.nonOriginatingValue !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.nonOriginatingValue).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.directLabourCost}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.directLabourCost !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.directLabourCost).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.otherCost}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.otherCost !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.otherCost).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.baseUnit}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.baseUnit !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.baseUnit).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.directOverheardCost}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{deminimisRooHolder?.ftaOriginCalculationEntity?.directOverheadCost !== null ? Number(deminimisRooHolder?.ftaOriginCalculationEntity?.directOverheadCost).toFixed(2) : `-`}</label>
                                    </span>
                                </div>
                            </CngGridItem>

                            <CngGridItem xs={12} sm={4}>
                                <div className={`field-vertical--label-value`}>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-label`}>{FtaTranslatedTextsObject.qvc} &#47;{FtaTranslatedTextsObject.rvc}</label>
                                    </span>
                                    <span className={`field-vertical--item`}>
                                        <label className={`field-value`}>{qvcRvc}</label>
                                    </span>
                                </div>
                            </CngGridItem>
                        </Grid>
                    </CngGridItem>
                </Grid>
            </div>
            {/* end card body */}

            {/* card footer */}
            <RulesOfOriginListCardDetailBottom product={dates} key={datesCardKey}/>

        </Card>
    )
}

const RulesOfOriginDeminimisDetails = Object.freeze({
    FormBody: FormBody,
    initialValues: initialValues
})

export default RulesOfOriginDeminimisDetails;